import { render, staticRenderFns } from "./TerrainPrefillInbox.vue?vue&type=template&id=445003d1&scoped=true"
import script from "./TerrainPrefillInbox.vue?vue&type=script&lang=js"
export * from "./TerrainPrefillInbox.vue?vue&type=script&lang=js"
import style0 from "./TerrainPrefillInbox.vue?vue&type=style&index=0&id=445003d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445003d1",
  null
  
)

export default component.exports